import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Decimal from 'decimal.js';
import H3Text from '@Uilib/h3Text';
import { Select, Table, notification } from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import BatchSelector from '@Components/Inventory/Indent/CreateIndent/BatchSelector';
import Helpers from '@Apis/helpers';
import { QUANTITY } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import invoiceActions from '../../../../../actions/invoiceActions';
import { CloseOutlined } from '@ant-design/icons';
import SelectDepartment from '@Components/Common/SelectDepartment';
import FormHelpers from '../../../../../helpers/FormHelpers';
const { Option } = Select;
import './style.scss';


class IssueStockForInvoice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      productListColumns: [
        {
          title: 'PRODUCT',
          width: '300px',
          render: (text, record) => {
            const {
              data,
            } = this.props;
            return (
              <div>
                <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
                  {`#${record?.product_sku_info?.internal_sku_code}`}
                </Link>
                <span>{` - ${record?.product_sku_name}`}</span>
              </div>
            );
          },
        },
        {
          title: 'DEPARTMENT',
          width: '150px',
          render: (record) => {
            const {
              departments, user, updateData, data,
            } = this.props;
            return (
              <Fragment>
                <SelectDepartment
                  title="Department"
                  hideTitle
                  selectedDepartment={record?.tenant_department_id}
                  noDropdownAlign
                  onChange={(value) => {
                    const tdId = value?.tenant_department_id;
                    const copyData = JSON.parse(JSON.stringify(data));
                    let copyRecord = {};
                    copyData.forEach((obj) => {
                      if (obj.key === record.key) {
                        if (record?.bundle_products?.length) {
                          const bundleProducts = JSON.parse(JSON.stringify(obj?.bundle_products));
                          for (let i = 0; i < bundleProducts?.length; i++) {
                            const bundleProductBatches = bundleProducts[i]?.product_batches;
                            bundleProducts[i].product_batches = bundleProductBatches;
                            const matchingBatches = bundleProducts[i]?.tenant_department_wise_product_batches[tdId] || [];
                            bundleProducts[i].product_batches = matchingBatches.map((batch) => ({ ...batch, batch_in_use: true }));
                            copyRecord = { ...obj, tenant_department_id: tdId, bundle_products: bundleProducts };
                            this.handleQuantityChange(copyRecord, obj.quantity);
                          }
                        } else {
                          const matchingBatches = obj.tenant_department_wise_product_batches[tdId] || [];
                          copyRecord = { ...obj, tenant_department_id: tdId, product_batches: matchingBatches.map((batch) => ({ ...batch, batch_in_use: true })) };
                          this.handleQuantityChange(copyRecord, obj.quantity);
                        }
                      }
                    });
                  }}
                  customStyle={{
                    border: '1px solid rgba(68, 130, 218, 0.2)',
                    height: '32px',
                    width: '150px',
                    borderRadius: '4px',
                  }}
                  emptyNotAllowed
                  showSearch
                  tenantId={record?.tenantId}
                  tenentLevelDepartment
                />
              </Fragment>
            );
          },
        },
        {
          title: 'AVAILABLE STOCK',
          render: (text, record) => {
            let availableQty = 0;
            const { allStock } = this.props;
            if (record?.bundle_products?.length) {
              const arr = [];
              for (let i = 0; i < record?.bundle_products?.length; i++) {
                const qty = Helpers.getValueTotalInObject(record?.bundle_products?.[i]?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
                arr.push(qty / ((record?.bundle_products[i]?.so_quantity || 1) / Number(record?.so_quantity || 1)));
              }
              availableQty = Math.min(...arr);
            } else {
              availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
            }
            return (
              <div style={{ width: '120px' }}>
                {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
                {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
                  && (
                    <Fragment>
                      {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.[0]?.ratio) * record?.product_sku_info?.uom_info?.ratio, (record?.uom_info?.[0]?.precision || 0))} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                    </Fragment>
                  )}
                {!['SERVICE', 'BUNDLE'].includes(record?.product_sku_info?.product_type?.toUpperCase()) && availableQty ? (
                  <H3Text
                    text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                    className="table-subscript"
                  />
                ) : ''}
              </div>
            );
          },
        },
        {
          title: 'PENDING',
          render: (item) => (
            <Fragment>
              {`${QUANTITY(item?.issueStockQuantity - item?.invoice_line_adjustment_issued_quantity, item?.uom_info?.precision)} ${item?.uom_info?.[0]?.uqc?.toProperCase()}`}
            </Fragment>
          ),
        },
        {
          title: 'QUANTITY',
          width: '200px',
          render: (record) => {
            const {
              formSubmitted,
            } = this.state;
            const qytValidation = formSubmitted && (Number(record.quantity) <= 0 || Number(record.quantity) > record?.issueStockQuantity - record?.invoice_line_adjustment_issued_quantity);
            const showErrorValidation = Number(record?.quantity) > record?.issueStockQuantity - record?.invoice_line_adjustment_issued_quantity;
            const { allStock } = this.props;
            let availableQty = 0;
            if (record?.bundle_products?.length) {
              const arr = [];
              for (let i = 0; i < record?.bundle_products?.length; i++) {
                const qty = Helpers.getValueTotalInObject(record?.bundle_products?.[i]?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
                arr.push(qty / ((record?.bundle_products[i]?.so_quantity || 1) / Number(record?.so_quantity || 1)));
              }
              availableQty = Math.min(...arr);
            } else {
              availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use && (allStock ? !item?.is_rejected_batch : true))), 'available_qty');
            }
            const valiDationForAvailableQty = record?.bundle_products?.length ? (Number(record?.quantity) > availableQty) : (Number(record?.quantity) > availableQty);

            return (
              <Fragment>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <H3FormInput
                    value={record.quantity}
                    type="number"
                    labelClassName="orgFormLabel"
                    inputClassName={`orgFormInput ${qytValidation ? 'orgFormInputError' : ''} `}
                    name={valiDationForAvailableQty ? 'quantity less then or equal to available stock' : 'quantity less then or equal to pending quantity'}
                    onChange={(event) => this.handleQuantityChange(record, (event.target.value || 0), record?.showFreebie, availableQty)}
                    showError={showErrorValidation || valiDationForAvailableQty}
                  />
                  <div style={{ marginLeft: '6px' }}>
                    {record?.uom_info?.[0]?.uqc?.toProperCase()}
                  </div>
                </div>
              </Fragment>
            );
          },
        },
        {
          title: '',
          render: (text, record) => {
            const { data } = this.props;
            return (
              <Fragment>
                {data.length !== record.key && (
                  <div className="update-invoice__delete-line-button" onClick={() => this.handleDelete(record.key)}>
                    <CloseOutlined />
                  </div>
                )}
              </Fragment>
            );
          },
          width: '40px',
          fixed: 'right',
        },
      ].filter((item) => !item.hidden),
      bundleProductListColumns: [
        {
          title: 'PRODUCT',
          render: (text, record) => (
            <div className="invoice-table__product-name">
              <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
                {record?.product_sku_name}
              </Link>
            </div>
          ),
        },
        {
          title: 'AVAILABLE STOCK',
          render: (text, record) => {
            const availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty');
            return (
              <Fragment>
                {['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && '-'}
                {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && record?.product_sku_name
                  && (
                    <Fragment>
                      {availableQty ? `${QUANTITY((availableQty / record?.uom_info?.[0]?.ratio) * record?.product_sku_info?.uom_info?.ratio, record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase()}` : <span style={{ color: 'red', fontSize: '11px', whiteSpace: 'nowrap' }}>OUT OF STOCK</span>}
                    </Fragment>
                  )}
                {!['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type) && Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty') ? (
                  <H3Text
                    text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                    className="table-subscript"
                  />
                ) : ''}
              </Fragment>
            );
          },
        },
        {
          title: 'QUANTITY IN BUNDLE',
          hidden: !this.props?.selectedOrderForInvoice && !this.props.moRmLines,
          render: (text, record) => `${QUANTITY(record?.so_quantity || '0', record?.uom_info?.[0]?.precision)} ${record?.uom_info?.[0]?.uqc?.toProperCase() || ''}`,
        },
        {
          title: 'INVOICE QUANTITY',
          dataIndex: 'quantity',
          render: (text, record) => (
            <div>{`${Helpers.getValueTotalInObject(record?.product_batches, 'consumed_qty') || 0} ${record?.uom_info?.[0]?.uqc?.toProperCase()}`}</div>
          ),
        },
      ],
    };
  }

  handleDelete = (key) => {
    const { updateData, data } = this.props;
    if (data?.length === 1) {
      notification.error({
        message: 'Atleast one line item is required',
        placement: 'top',
        duration: 4,
      });
    } else {
      const copyData = data?.filter((item) => item.key !== key);
      updateData(copyData);
    }
  }

  handleQuantityChange(record, value, freeValue, availableQty) {
    const {
      updateData, data, allStock,
    } = this.props;
    const copyData = JSON.parse(JSON.stringify(data));

    if (record?.bundle_products?.length) {
      const bundleProducts = JSON.parse(JSON.stringify(record?.bundle_products));
      for (let i = 0; i < bundleProducts?.length; i++) {
        const bundleProductBatches = bundleProducts[i]?.product_batches;
        for (let j = 0; j < bundleProductBatches?.length; j++) {
          bundleProductBatches[j].consumed_qty = 0;
        }
        let remainingQty = (Number(value) + (Number(freeValue) || 0)) * (bundleProducts[i]?.bundle_quantity || 1);
        for (let j = 0; j < bundleProductBatches?.length; j++) {
          const avlQty = ((bundleProductBatches?.[j]?.available_qty / bundleProducts[i]?.uom_info?.[0]?.ratio) * bundleProducts[i]?.product_sku_info?.uom_info?.ratio) * (bundleProducts[i]?.bundle_quantity || 1);
          if (bundleProductBatches[j]?.batch_in_use) {
            if (remainingQty > 0 && parseFloat((bundleProductBatches[j].consumed_qty)) < avlQty) {
              bundleProductBatches[j].consumed_qty = (avlQty > remainingQty ? remainingQty : avlQty);
              remainingQty -= bundleProductBatches[j].consumed_qty;
            } else {
              bundleProductBatches[j].consumed_qty = 0;
              remainingQty -= bundleProductBatches[j].consumed_qty;
            }
          }
        }
        bundleProducts[i].product_batches = bundleProductBatches;
        const updatedData = copyData.map((obj) => {
          if (obj.key === record.key) {
            return {
              ...obj,
              quantity: value,
              tenant_department_id: record.tenant_department_id,
              bundle_products: bundleProducts,
            };
          }
          return obj;
        });
        updateData(updatedData);
      }
    } else {
      const batches = record?.product_batches;
      let remainingQty = new Decimal(value || 0).plus(new Decimal(freeValue || 0))
      for (let i = 0; i < batches?.length; i++) {
        batches[i].consumed_qty = 0;
      }
      for (let i = 0; i < batches?.length; i++) {
        const availableQty = new Decimal(QUANTITY(batches?.[i]?.available_qty || 0, record?.uom_info?.[0]?.precision));
        const fromRatio = new Decimal(record?.uom_info?.[0]?.ratio || 1);
        const toRatio = new Decimal(record?.product_sku_info?.uom_info?.ratio || 1);

        const avlQty = availableQty.div(fromRatio).times(toRatio);
        let consumedQty = new Decimal(batches[i]?.consumed_qty || 0);
        if (batches[i]?.batch_in_use && (allStock ? !batches[i]?.is_rejected_batch : true)) {
          if (remainingQty.gt(0) && consumedQty.lt(avlQty)) {
            const assignQty = Decimal.min(avlQty, remainingQty);
            batches[i].consumed_qty = assignQty.toNumber();
            remainingQty = remainingQty.minus(assignQty);
          } else {
            batches[i].consumed_qty = 0;
          }
        }
      }
      const updatedData = copyData.map((obj) => {
        if (obj.key === record.key) {
          return {
            ...obj,
            quantity: value,
            tenant_department_id: record.tenant_department_id,
            product_batches: batches,
            batchesAvailableQyt: availableQty,
          };
        }
        return obj;
      });
      updateData(updatedData);
    }
  }

  getBundleLineKeys(rows) {
    const keys = [];
    for (let i = 0; i < rows?.length; i++) {
      if (rows[i]?.bundle_products?.length) {
        keys.push(rows[i]?.key);
      }
    }
    return keys;
  }

  toggleBatch(record, adjustmentRow) {
    const { updateData, data } = this.props;

    const newData = data.map((item) => {
      if (item.key === adjustmentRow.key) {
        // Target the matching adjustmentRow
        return {
          ...item,
          product_batches: item.product_batches.map((batch) => {
            if (batch.batch_id === record.batch_id) {
              // Target the specific batch
              return {
                ...batch,
                batch_in_use: !batch.batch_in_use, // Toggle `batch_in_use`
                consumed_qty: 0,
              };
            }
            return {
              ...batch,
              consumed_qty: 0,
            }; // Leave other batches unchanged
          }),
          quantity: 0, // Adjust quantity for the matched row
        };
      }
      return item; // Leave other rows unchanged
    });
    updateData(newData); // Update state with the modified data
  }

  toggleBatchInner(record, adjustmentRow) {
    const { updateData, data } = this.props;
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData?.length; i++) {
      const newData = copyData[i];
      if (newData?.key === adjustmentRow?.parentKey) {
        newData.quantity = 0;
        const bundleProducts = newData?.bundle_products;
        for (let j = 0; j < bundleProducts?.length; j++) {
          const rowBatches = bundleProducts[j]?.product_batches;
          for (let k = 0; k < rowBatches?.length; k++) {
            if (rowBatches[k]?.batch_id === record?.batch_id) {
              rowBatches[k].batch_in_use = !rowBatches[k]?.batch_in_use;
            }
            rowBatches[k].consumed_qty = 0;
          }
        }
      }
    }
    updateData(copyData);
  }

  updateBatchValue(key, value, label, batchId) {
    const { updateData, data } = this.props;
    const copyData = JSON.parse(JSON.stringify(data));
    const newUpdatedData = copyData.map((obj) => {
      if (obj.key === key) {
        let productBatches = obj?.product_batches;
        productBatches = productBatches?.map((productBatch) => {
          if (productBatch.batch_id === batchId) {
            // Check if label is 'consumed_qty' and apply logic based on available_qty
            if (label === 'consumed_qty') {
              return {
                ...productBatch,
                [label]: value > productBatch?.available_qty ? productBatch?.available_qty : value,
              };
            }
            // For other labels, simply update with the provided value
            return {
              ...productBatch,
              [label]: value,
            };
          }
          return productBatch;
        });
        let qty = productBatches?.reduce(
          (sum, batch) => sum.plus(new Decimal(batch?.consumed_qty || 0)),
          new Decimal(0)
        ).toNumber();
        return {
          ...obj,
          product_batches: productBatches,
          quantity: qty,
        };
      }
      return obj;
    });

    updateData(newUpdatedData);
  }

  render() {
    const {
      loading, data, allStock, toggleAllStock, updateData, title, moRmLines, selectedOrderForInvoice, disabled, issueStockForInvoice, issueStockForInvoiceLoading, selectedInvoice, callback, history,
    } = this.props;
    const {
      productListColumns, bundleProductListColumns,
    } = this.state;
    return (
      <div className="issue-stock-lines__wrapper">
        <Table
          title={title}
          bordered
          loading={loading}
          showHeader
          size="small"
          scroll={{ x: 'max-content' }}
          columns={productListColumns}
          dataSource={data}
          pagination={false}
          expandable={{
            rowExpandable: (record) => (record?.bundle_products?.length > 0 || (Helpers.getValueTotalInObject(record?.product_batches, 'available_qty')) > 0) && !['SERVICE', 'NON_STORABLE'].includes(record?.product_sku_info?.product_type),
            defaultExpandedRowKeys: this.getBundleLineKeys(data),
            expandedRowRender: (record) => (
              <Fragment>
                {record.bundle_products?.length ? (
                  <div className="inv__bundle-products__wrapper">
                    <Table
                      bordered
                      loading={loading}
                      showHeader
                      size="small"
                      columns={bundleProductListColumns}
                      dataSource={record?.bundle_products}
                      pagination={false}
                      expandable={{
                        defaultExpandAllRows: false,
                        rowExpandable: (innerRecord) => innerRecord?.product_sku_name && Helpers.getValueTotalInObject(innerRecord?.product_batches, 'available_qty'),
                        expandedRowRender: (innerRecord) => (
                          <BatchSelector
                            innerBatchSelector
                            batchMethod={innerRecord?.batchConsumptionMethod}
                            updateBatchConsumptionMethod={(value) => {
                              const copyData = JSON.parse(JSON.stringify(data));
                              const sortedData = copyData?.map((item) => {
                                if (innerRecord.key === item.key) {
                                  item.batchConsumptionMethod = value;
                                  item.product_batches = Helpers.batchSelectionMethod(value, item.product_batches, item.quantity, allStock, null, item?.uom_info);
                                }
                                return {
                                  ...item,
                                };
                              });
                              updateData(sortedData);
                            }}
                            batches={innerRecord?.product_batches}
                            uomInfo={innerRecord?.uom_info?.[0]}
                            productUomInfo={innerRecord?.product_sku_info?.uom_info}
                            expiryDays={innerRecord?.product_sku_info?.expiry_days}
                            itemsRow={innerRecord}
                            onToggleBatch={(batch, adjustmentRow) => this.toggleBatchInner(batch, adjustmentRow)}
                            productInfo={record}
                          />
                        ),
                      }}
                      scroll={{ x: 'max-content' }}
                    />
                  </div>
                ) : (
                  <React.Fragment>
                    <BatchSelector
                      allStock={allStock}
                      upDateAllStock={() => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const filteredData = copyData?.map((item) => {
                          if (record?.key === item?.key) {
                            for (let i = 0; i < item?.product_batches?.length; i++) {
                              item.product_batches[i].consumed_qty = 0;
                            }
                            item.quantity = 0;
                          }
                          return {
                            ...item,
                          };
                        });
                        updateData(filteredData);
                        toggleAllStock();
                      }}
                      batchMethod={record?.batchConsumptionMethod}
                      updateBatchConsumptionMethod={(value) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const sortedData = copyData?.map((item) => {
                          if (record.key === item.key) {
                            item.batchConsumptionMethod = value;
                            item.product_batches = Helpers.batchSelectionMethod(value, item.product_batches, item.quantity, allStock, null, item?.uom_info);
                            item.free_quantity = 0;
                          }
                          return {
                            ...item,
                          };
                        });
                        updateData(sortedData);
                      }}
                      batches={record?.product_batches || []}
                      uomInfo={record?.uom_info?.[0]}
                      productUomInfo={record?.product_sku_info?.uom_info}
                      expiryDays={record?.product_sku_info?.expiry_days}
                      itemsRow={record}
                      onToggleBatch={(batch, adjustmentRow) => this.toggleBatch(batch, adjustmentRow)}
                      productInfo={record}
                      updateBatchValue={(value, label, batchId) => this.updateBatchValue(record?.key, value, label, batchId)}
                    />

                  </React.Fragment>
                )}
              </Fragment>
            ),
          }}
        />

        <div className="custom-drawer__footer" style={{ display: 'flex', width: '955px', paddingTop: '10px' }}>
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Issue Stock"
            onClick={() => {
              this.setState({ formSubmitted: true });
              const payload = {
                adjustments: data?.flatMap((item) => {
                  if (item?.bundle_products?.length > 0) {
                    return item.bundle_products.map((bundle) => ({
                      invoice_id: selectedInvoice?.invoice_id,
                      invoice_line_id: bundle?.invoice_line_id,
                      enteredQuantity: Number(item?.quantity),
                      pendingQuantity: item?.issueStockQuantity - item?.invoice_line_adjustment_issued_quantity,
                      quantity: bundle.product_batches?.filter((batch) => batch.consumed_qty > 0).reduce((acc, batch) => acc + batch.consumed_qty, 0) || 0,
                      product_batches: bundle.product_batches?.filter((batch) => batch.consumed_qty > 0).map((batch) => ({
                        ...batch,
                        quantity: batch.consumed_qty,
                        manufacturing_date: batch?.manufacturing_date ? FormHelpers.dateFormatter(batch?.manufacturing_date, item?.manufacturingDateFormat) : null,
                        expiry_date: batch?.expiry_date ? FormHelpers.dateFormatter(batch?.expiry_date, item?.expiryDateFormat) : null,
                      })),
                    }));
                  }
                  return {
                    invoice_id: selectedInvoice?.invoice_id,
                    invoice_line_id: item?.invoice_line_id,
                    quantity: item?.quantity,
                    enteredQuantity: Number(item?.quantity),
                    batchesAvailableQyt: item?.batchesAvailableQyt,
                    pendingQuantity: item?.issueStockQuantity - item?.invoice_line_adjustment_issued_quantity,
                    product_batches: item.product_batches?.filter((batch) => batch.consumed_qty > 0)?.map((batch) => ({
                      ...batch,
                      quantity: batch.consumed_qty,
                      manufacturing_date: batch?.manufacturing_date ? FormHelpers.dateFormatter(batch?.manufacturing_date, item?.manufacturingDateFormat) : null,
                      expiry_date: batch?.expiry_date ? FormHelpers.dateFormatter(batch?.expiry_date, item?.expiryDateFormat) : null,
                    })),
                  };
                }),
              };
              const payloadValidation = payload?.adjustments?.every((item) => item?.quantity > 0
                && item?.enteredQuantity <= item.pendingQuantity
                && item?.product_batches?.length > 0
                && item?.quantity <= item?.product_batches.reduce((acc, batch) => acc + batch.quantity, 0));
              if (payloadValidation) {
                issueStockForInvoice(payload, () => {
                  callback();
                });
              }
            }}
            style={{
              width: '180px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
            isLoading={issueStockForInvoiceLoading}
          />
        </div>
      </div>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, OfferReducers, InvoiceReducers, DepartmentReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  updateCustomPurchaseOrderLoading: PurchaseOrderReducers.updateCustomPurchaseOrderLoading,
  selectedPurchaseOrder: PurchaseOrderReducers.selectedPurchaseOrder,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
  issueStockForInvoiceLoading: InvoiceReducers.issueStockForInvoiceLoading,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = (dispatch) => ({
  issueStockForInvoice: (payload, callback) => dispatch(invoiceActions.issueStockForInvoice(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueStockForInvoice));
